import { UserInfo, UserProfile } from '../types';

export function transformUserProfileResponse(
  response: any,
  enableIdpProxy: boolean
): UserInfo {
  if (enableIdpProxy) {
    return {
      userProfile: response.userProfile,
      locale: response.locale,
      lastLogin: response.lastLogin
    };
  }
  const profile = response.profile || {};
  const { locale,  ...profileWithoutLocale } = profile;

  return {
    userProfile: {
      ...profileWithoutLocale,
    } as UserProfile,
    locale: locale,
    lastLogin: response.lastLogin
  };
}
